/**
 * @class
 */
export class BaseResponse {
    constructor(data = {}) {
        this.data = data;
    }
}
